import { get } from "lodash";

export const getContactDetails = state => get(state, "contact", {});
export const getContactMail = state => get(state, "contact.email.value", "");
